import { render } from "./QrScanner.vue?vue&type=template&id=1c5ea543&scoped=true"
import script from "./QrScanner.vue?vue&type=script&lang=js"
export * from "./QrScanner.vue?vue&type=script&lang=js"

import "./QrScanner.vue?vue&type=style&index=0&id=1c5ea543&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5ea543"]])

export default __exports__